import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { selfOrFunction } from '../../utils';

import { AvatarProps } from './types';

export const avatarSizeUnitMap = {
  nano: 1.5,
  micro: 2,
  small: 3,
  regular: 4,
  large: 5,
  xlarge: 7,
  xxlarge: 22.5,
};

export const AvatarContainer = styled.div<AvatarProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  line-height: 158%;
  border-radius: 50%;
  background-color: ${(props) =>
    selfOrFunction(props, props.backgroundColor) ?? props.theme.mosaiq.colors.grey};

  ${({ size = 'regular', theme }) =>
    css`
      min-width: ${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px;
      min-height: ${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px;
      max-width: ${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px;
      max-height: ${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px;
    `};

  ${({ image }) =>
    !!image &&
    css`
      background-origin: content-box;
      background-size: cover;
      background-position: top center;
      background-repeat: no-repeat;
      object-fit: cover;
      background-image: ${`url(${image})`};
    `};

  ${({ overlay, theme }) =>
    overlay &&
    css`
      & > * {
        z-index: 3;
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background-color: ${rgba(theme.mosaiq.colors.black, 0.4)};
        backdrop-filter: blur(2px);
        z-index: 1;
      }
    `};
`;
